import React, { useEffect, useState } from "react";
import { Dropdown, HelpDrawerToggle } from "@cmsgov/ds-medicare-gov";
import { sendTealiumEvent, useTranslate } from "../../../helpers";
import LearnAboutTiers from "./LearnAboutTiers";
import {
  AbstractBenefits,
  PharmacyPreferencesAndFrequencies,
} from "../../../@types";
import { dropdownTranslations, filterOptions } from "./AbstractBenefitsHelpers";
import AbstractBenefitsTableContainer from "./AbstractBenefitsTableContainer";

export const AbstractBenefitsDropdown: React.FunctionComponent<{
  abstractBenefits: AbstractBenefits;
}> = ({ abstractBenefits }) => {
  const t = useTranslate();
  const [pharmacyPreference, setPharmacyPreference] = useState<
    PharmacyPreferencesAndFrequencies | string
  >("");
  const [showDrugTierHelp, setShowDrugTierHelp] = useState<boolean>(false);
  const [filteredOptions, setFilteredOptions] = useState<
    Array<PharmacyPreferencesAndFrequencies>
  >([]);

  useEffect(() => {
    const filteredOptions = filterOptions(abstractBenefits);
    const defaultOption = PharmacyPreferencesAndFrequencies[filteredOptions[0]];
    setFilteredOptions(filteredOptions);
    setPharmacyPreference(defaultOption);
  }, [abstractBenefits]);

  return filteredOptions.length > 0 ? (
    <div className="the-abstract-table-section">
      <div className="AbstractBenefits__infoBox ds-u-padding--2">
        <p>{t("abstract_benefits.info")}</p>
        <HelpDrawerToggle
          helpDrawerOpen={showDrugTierHelp}
          showDrawer={(): void => {
            setShowDrugTierHelp(true);
            sendTealiumEvent("Help Drawer", "Learn About Tiers");
          }}
        >
          {t("plan_terms.learn_about_tiers")}
        </HelpDrawerToggle>
      </div>

      <Dropdown
        className="PharmAndFreqSelector"
        label={t("abstract_benefits.dropdown.label")}
        id="abstract-benefits-dropdown"
        name="abstract-benefits-dropdown"
        onChange={(e: React.SyntheticEvent<HTMLSelectElement, Event>): void => {
          const selectedOption = e.currentTarget
            .value as PharmacyPreferencesAndFrequencies;
          // istanbul ignore next: tested elsewhere
          sendTealiumEvent(
            "Plan Details ",
            `Tier Drug Cost ${selectedOption} selected`
          );
          setPharmacyPreference(selectedOption);
        }}
        value={pharmacyPreference}
        options={[]}
      >
        {filteredOptions.map((prefAndFreq: string, i: number) => (
          <option
            value={PharmacyPreferencesAndFrequencies[prefAndFreq]}
            key={i}
          >
            {t(dropdownTranslations[prefAndFreq])}
          </option>
        ))}
      </Dropdown>

      <AbstractBenefitsTableContainer
        pharmacyPreference={
          pharmacyPreference as PharmacyPreferencesAndFrequencies
        }
        abstractBenefits={abstractBenefits}
      />
      <div className="ds-u-margin-top--5 ds-u-margin-bottom--7">
        <hr />
      </div>

      {showDrugTierHelp && (
        <LearnAboutTiers
          onSetShowDrugTierHelp={(show: boolean): void =>
            setShowDrugTierHelp(show)
          }
        />
      )}
    </div>
  ) : null;
};

export default AbstractBenefitsDropdown;
